
import React, { useEffect, useState } from "react"
import SuccessMessageDesktop from "./SuccessMessageDesktop"
import SuccessMessageMobile from "./SuccessMessageMobile"
import { useMediaQuery } from "react-responsive"

const SuccessMessage: React.FC = () => {
    const isDesktop = useMediaQuery({ minWidth: 1140 })
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        setIsMounted(true)
    }, [])

    // Renderiza nulo até que o componente esteja montado para evitar problemas de hidratação
    if (!isMounted) {
        return null
    }

    return (
        <>
            {isDesktop ? (
                <SuccessMessageDesktop />
            ) : (
                <SuccessMessageMobile />
            )}
        </>
    )
}

export default SuccessMessage
